import React, { useState, useEffect, useContext } from "react";
import "./State.css";
import axios from "axios";
import AddStateForm from "./AddState";
import EditStateForm from "./EditState";
import { toast } from "react-toastify";
import { AuthContext } from "../../Context/AuthContext";
import { logActivity } from "../../utils/LogActivity";
import Preloader from "../../shared/PreLoaders";
import { Authorization } from "../../Context/Authorization";

const State = () => {
  const [state, setState] = useState([]);
  const [showAddPopup, setShowAddPopup] = useState(false);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [loading, setLoading] = useState(true);
  const [currentState, setCurrentState] = useState(null);
  const { permissions, userId } = useContext(AuthContext);
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    setLoading(true);
    const fetchStates = async () => {
      try {
        const config = Authorization();

        const response = await axios.get(`${Api}/api/states`, config);
        const data = response.data;
        if (Array.isArray(data)) {
          setState(data);
          await logActivity(userId, "Viewed State", "State Page", Api);
        } else {
          console.error("API did not return an array", data);
        }
      } catch (err) {
        console.error("Error fetching data", err);
      }
      setLoading(false);
    };

    fetchStates();
  }, []);

  const handleShowAddPopup = () => {
    setShowAddPopup(true);
  };

  const handleCloseAddPopup = () => {
    setShowAddPopup(false);
  };

  const handleShowEditPopup = (state) => {
    setCurrentState(state);
    setShowEditPopup(true);
  };

  const handleCloseEditPopup = () => {
    setShowEditPopup(false);
    setCurrentState(null);
  };

  const handleDeleteState = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this State?"
    );
    if (!confirmDelete) {
      return;
    }
    try {
      await axios.delete(`${Api}/api/states/${id}`);
      setState(state.filter((state) => state._id !== id));
      toast.success("Deleted Successfully");
    } catch (err) {
      console.error("Error deleting state", err);
    }
    await logActivity(userId, "Deleted State", "State Page", Api);
  };
  const handleAddState = (newState) => {
    setState([...state, newState]);
  };

  return (
    <div>
      <Preloader loading={loading} />
      <div className="page-header">
        <h3 className="page-title"> State </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(event) => event.preventDefault()}>
                VFC
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              State
            </li>
          </ol>
        </nav>
      </div>

      {loading ? (
        <div className="loading-container"></div>
      ) : (
        <>
          <div className="card">
            <div className="card-body">
              <div className="row icons-list">
                {permissions.includes("AddState") && (
                  <div className="Add_btn">
                    <button
                      type="button"
                      className="btn btn-inverse-success"
                      onClick={handleShowAddPopup}
                    >
                      Create New
                    </button>
                  </div>
                )}
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr className="table table-hover">
                        <th>
                          <span>SI.No</span>
                        </th>
                        <th>
                          <span>State Name</span>
                        </th>
                        <th>
                          <span>State Code</span>
                        </th>
                        {permissions.includes("EditState") &&
                          permissions.includes("DeleteState") && (
                            <th>
                              <span>Actions</span>
                            </th>
                          )}
                      </tr>
                    </thead>
                    <tbody>
                      {state.map((item, index) => (
                        <tr key={item._id}>
                          <td>{index + 1}</td>
                          <td>{item.stateName}</td>
                          <td className="text-success">{item.stateCode}</td>

                          {permissions.includes("EditState") &&
                            permissions.includes("DeleteState") && (
                              <td>
                                <i
                                  className="mdi mdi-pen"
                                  style={{
                                    fontSize: "1.5rem",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleShowEditPopup(item)}
                                />
                                <i
                                  className="mdi mdi-delete"
                                  style={{
                                    fontSize: "1.5rem",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleDeleteState(item._id)}
                                ></i>
                              </td>
                            )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          {showAddPopup && (
            <AddStateForm
              onClose={handleCloseAddPopup}
              onAddState={handleAddState}
            />
          )}
          {showEditPopup && currentState && (
            <EditStateForm
              state={currentState}
              onClose={handleCloseEditPopup}
            />
          )}
        </>
      )}
    </div>
  );
};
export default State;
